module.exports = __webpack_public_path__ + "static/media/stanford.19cacf0d.png";